// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__277GW","validationTips":"StatementDescriptor_validationTips__y5ERc"};